import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Spin, Progress } from "@kdcloudjs/kdesign";
import styles from "../bigScreen.less";

function Refresh(props) {
  const { model, cloudId, processValue, lastUpdateTime, pageState, getLangMsg } = props;
  // const [refreshFlag, setRefreshFlag] = useState(false)
  // 轮询
  const handleRefresh = () => {
    props.refreshClick();
  };

  return (
    <div className={styles.refresh}>
      {pageState === 3 ? (
        <div className={styles.refreshingNumber}>
          <div className={styles.refreshingText} title={`${getLangMsg('refresh.key0001')}${processValue}%`}>{`${getLangMsg('refresh.key0001')}${processValue}%`}</div>
          <Progress percent={processValue} strokeColor='#397FC1' trailColor='#515171' strokeWidth={2} showInfo={false}/>
        </div>
      ) : (
        <div className={styles.refreshedNumber}>
          {`${getLangMsg('refresh.key0002')}${lastUpdateTime}`}
        </div>
      )}

      <div
        id="refreshText"
        className={`${styles.refreshText} ${
          pageState === 3 ? styles.refreshingHover : styles.refreshedHover
        }`}
        title={pageState === 3 ? getLangMsg('refresh.key0003') : null}
      >
        {pageState === 3 ? (
          <>
            {/* <div style={{ transform: "scale(0.6)" }}> */}
            <div style={{marginRight: '2px'}}>
              <Spin
                name="Spin"
                type="component"
                style={{
                  "--kd-c-spin-component-dot-item-color-border": "#3DAAED",
                  "--kd-c-spin-component-dot-color-border": "#262E4F",
                  "--kd-c-spin-page-dot-item-sizing-square": "16px"
                }}
              />
            </div>
            <span>{getLangMsg('refresh.key0004')}</span>
          </>
        ) : (
          <div className={styles.refreshClick} onClick={handleRefresh}><span>{getLangMsg('refresh.key0005')}</span></div>
        )}
      </div>
    </div>
  );
}
Refresh.propTypes = {
  baseinfo: PropTypes.object,
  name: PropTypes.string,
};
export default Refresh;
